import baseApi from '@store/api/baseApi';

export const materialsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		addBulkFabric: builder.mutation({
			query: (files) => {
				const formData = new FormData();
				files.forEach((file) => {
					formData.append('files', file);
				});

				return {
					url: `/material/bulk-upload-doc`,
					method: 'POST',
					body: formData
				};
			}
		}),
		markMaterialForAlert: builder.mutation({
			query: ({ materialId, alertQuantity, needBalanceAlert }) => ({
				url: `/material/${materialId}/update-balance-alert${alertQuantity !== null ? `?balanceAlertLimit=${alertQuantity}&needBalanceAlert=${needBalanceAlert}` : `?needBalanceAlert=${needBalanceAlert}`}`,
				method: 'PUT'
			})
		})
	})
});

export const { useAddBulkFabricMutation, useMarkMaterialForAlertMutation } = materialsApi;
